// extracted by mini-css-extract-plugin
export default {"mouse-tooltip":"MouseTooltip_mouse-tooltip__c+yoG","fadeIn":"MouseTooltip_fadeIn__5TzwX","iconShake":"MouseTooltip_iconShake__6jy7k"};